var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.959 10.709C24.653 9.122 25 7.234 25 5.043V.027A.027.027 0 0024.973 0H.883A.886.886 0 000 .889v4.154c0 2.191.348 4.079 1.042 5.666.727 1.624 1.917 3.06 3.57 4.306l1.711 1.269a.892.892 0 010 1.431l-1.712 1.271c-1.653 1.245-2.843 2.681-3.57 4.305C.347 24.878 0 26.766 0 28.957v4.99c0 .029.024.053.053.053H24.88a.12.12 0 00.119-.12v-4.923c0-2.191-.347-4.079-1.041-5.666-.727-1.624-1.917-3.06-3.57-4.305l-1.711-1.27a.892.892 0 010-1.431l1.711-1.269c1.653-1.247 2.844-2.683 3.571-4.307zm-11.974 2.769a.875.875 0 001.031 0l3.506-2.543c.925-.679 1.602-1.416 2.032-2.209.295-.561.48-1.247.556-2.059.045-.489-.356-.888-.843-.888H6.733c-.487 0-.888.399-.842.888.075.812.261 1.497.555 2.058.43.794 1.108 1.531 2.033 2.21l3.506 2.543zm1.03 7.044a.875.875 0 00-1.031 0l-3.505 2.543c-.926.68-1.604 1.416-2.033 2.21-.295.561-.48 1.247-.556 2.059-.046.488.356.887.843.887h11.533c.487 0 .889-.399.843-.887-.075-.812-.261-1.498-.555-2.059-.43-.794-1.108-1.53-2.033-2.21l-3.506-2.543z",
    fill: "url(#hourglass_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hourglass_svg__a",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 34 -33.7589 0 12.5 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c1c1"
  })))));
}
export default SvgHourglass;